module.exports = __webpack_public_path__ + "static/sam1Small-6cb16f7db9e8074878bd57d32f541503.png";